export default __webpack_public_path__ + "static/media/co2_saved.793e57e1.svg";